import React, { useState, useEffect } from 'react'
import { Layout, Menu, Avatar, Spin } from 'antd'
import {
  HomeOutlined, BarChartOutlined, ToolOutlined, TeamOutlined,
  FileTextOutlined, LogoutOutlined, AppstoreOutlined,
  GlobalOutlined, TrophyOutlined, ReadOutlined, StockOutlined,
  DollarOutlined, QrcodeOutlined, DashboardOutlined, ThunderboltOutlined,
  FundOutlined, PieChartOutlined, LineChartOutlined, AreaChartOutlined,
  ExperimentOutlined, RocketOutlined, ApiOutlined, CodeOutlined,
  MenuFoldOutlined, PlusOutlined, CloseOutlined, EditOutlined, CheckOutlined,
} from '@ant-design/icons'
import { Input, Modal, Radio } from 'antd'
import { useNavigate, useLocation, Outlet, Navigate } from 'react-router-dom'
import { useAuth } from '../store/auth'
import { dashboardTabs, toolTabs, opsBackends, menuConfig } from '../api'

const { Sider, Content } = Layout

const ALL_MENU: any[] = [
  { key: '/', moduleKey: 'home', icon: <HomeOutlined />, label: '首页' },
  {
    key: '__ops_backends', moduleKey: '', icon: <AppstoreOutlined />, label: '运营常用后台',
    children: [
      { key: '__ext_zcadmin', label: '足彩后台', icon: <TrophyOutlined style={{ color: '#FF6B35' }} />, external: 'https://admin-pay.xiaohongdan.com/admin' },
      { key: '__ext_article', label: '文章&运营后台', icon: <ReadOutlined style={{ color: '#536DFE' }} />, external: 'https://dadmin.dongqiudi.com/admin/login' },
      { key: '__ext_jcgw', label: '竞彩官网', icon: <StockOutlined style={{ color: '#31C2A0' }} />, external: 'https://www.sporttery.cn/jc/zqszsc/' },
      { key: '__ext_500', label: '500.com', icon: <DollarOutlined style={{ color: '#FFC260' }} />, external: 'https://www.500.com/' },
      { key: '__ext_qrcode', label: '草料二维码', icon: <QrcodeOutlined style={{ color: '#9C27B0' }} />, external: 'https://cli.im/text' },
    ],
  },
  { key: '__ext_bdq', moduleKey: '', icon: <GlobalOutlined />, label: '不懂球数据中心', external: 'https://budongqiudi.com/' },
  { key: '__ext_work', moduleKey: '', icon: <GlobalOutlined />, label: 'Work项目平台', external: 'https://work.dongqiu.org/dashboard/overview' },
  { key: '/dashboard', moduleKey: 'dashboard', icon: <BarChartOutlined />, label: '数据看板' },
  { key: '/tools', moduleKey: 'tools', icon: <ToolOutlined />, label: '运营工具' },
  { key: '/users', moduleKey: 'users', icon: <TeamOutlined />, label: '用户管理' },
]

const DASH_ICONS = [
  <FundOutlined style={{ color: '#536DFE' }} />,
  <PieChartOutlined style={{ color: '#31C2A0' }} />,
  <LineChartOutlined style={{ color: '#FF6B35' }} />,
  <AreaChartOutlined style={{ color: '#9C27B0' }} />,
  <DashboardOutlined style={{ color: '#FFC260' }} />,
]
const TOOL_ICONS = [
  <ThunderboltOutlined style={{ color: '#FFC260' }} />,
  <RocketOutlined style={{ color: '#FF6B35' }} />,
  <ExperimentOutlined style={{ color: '#9C27B0' }} />,
  <ApiOutlined style={{ color: '#31C2A0' }} />,
  <CodeOutlined style={{ color: '#536DFE' }} />,
]
const OPS_ICONS = [
  <GlobalOutlined style={{ color: '#31C2A0' }} />,
  <GlobalOutlined style={{ color: '#FF6B35' }} />,
  <GlobalOutlined style={{ color: '#536DFE' }} />,
  <GlobalOutlined style={{ color: '#FFC260' }} />,
  <GlobalOutlined style={{ color: '#9C27B0' }} />,
]

export default function MainLayout() {
  const [collapsed, setCollapsed] = useState(false)
  const { user, loading, logout, can } = useAuth()
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const [dbTabs, setDbTabs] = useState<any[]>([])
  const [toolTabList, setToolTabList] = useState<any[]>([])
  const [opsList, setOpsList] = useState<any[]>([])
  const [addModalOpen, setAddModalOpen] = useState(false)
  const [addModalType, setAddModalType] = useState<'dashboard' | 'tools' | 'ops'>('dashboard')
  const [addForm, setAddForm] = useState({ name: '', url: '', owner: '', description: '', open_mode: 'iframe' })
  const [editMode, setEditMode] = useState(false)
  const [hiddenMenus, setHiddenMenus] = useState<string[]>([])

  const fetchTabs = () => {
    dashboardTabs.list().then((data: any) => setDbTabs(data)).catch(() => {})
    toolTabs.list().then((data: any) => setToolTabList(data)).catch(() => {})
    opsBackends.list().then((data: any) => setOpsList(data)).catch(() => {})
    menuConfig.getHidden().then((data: any) => setHiddenMenus(data)).catch(() => {})
  }

  useEffect(() => { fetchTabs() }, [])

  if (loading) {
    return <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><Spin size="large" /></div>
  }
  if (!user) return <Navigate to="/login" replace />

  const isSuperAdmin = user?.role === 'super_admin'

  const hideKey = (key: string) => {
    menuConfig.hide(key).then(() => setHiddenMenus(prev => [...prev, key])).catch(() => {})
  }

  const deleteBtn = (onDelete: (e: React.MouseEvent) => void) => (
    <CloseOutlined
      style={{ fontSize: 10, color: '#ff4d4f', flexShrink: 0, marginLeft: 4, padding: '2px 4px', borderRadius: 3, background: '#fff1f0' }}
      onClick={onDelete}
    />
  )

  const wrapLabel = (label: React.ReactNode, key: string, onDelete?: (e: React.MouseEvent) => void): React.ReactNode => {
    if (!editMode) return label
    const handler = onDelete ?? ((e: React.MouseEvent) => { e.stopPropagation(); hideKey(key) })
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', minWidth: 0 }}>
        <span style={{ flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{label}</span>
        {deleteBtn(handler)}
      </div>
    )
  }

  const menuItems: any[] = ALL_MENU
    .filter(m => can(m.moduleKey) && !hiddenMenus.includes(m.key))
    .map(m => {
      if (m.key === '__ops_backends') {
        return {
          key: m.key, icon: m.icon,
          label: wrapLabel(m.label, m.key),
          children: [
            ...m.children
              .filter((c: any) => !hiddenMenus.includes(c.key))
              .map((c: any) => ({
                key: c.key, icon: c.icon,
                label: wrapLabel(c.label, c.key),
                style: { borderRadius: 8, marginBottom: 4 },
              })),
            ...opsList.map((o, i) => ({
              key: `__ops_dyn_${o.id}`, icon: OPS_ICONS[i % OPS_ICONS.length],
              label: wrapLabel(o.name, `__ops_dyn_${o.id}`, (e) => {
                e.stopPropagation()
                opsBackends.remove(o.id).then(() => fetchTabs())
              }),
              style: { borderRadius: 8, marginBottom: 4 },
            })),
            ...(!editMode ? [{ key: '__ops_backends/__add', icon: <PlusOutlined />, label: '新增', style: { borderRadius: 8, marginBottom: 4 } }] : []),
          ],
        }
      }
      if (m.key === '/dashboard') {
        return {
          key: m.key, icon: m.icon,
          label: wrapLabel(m.label, m.key),
          children: [
            ...dbTabs.map((t, i) => ({
              key: `/dashboard/${t.id}`, icon: DASH_ICONS[i % DASH_ICONS.length],
              label: wrapLabel(t.name, `/dashboard/${t.id}`, (e) => {
                e.stopPropagation()
                dashboardTabs.remove(t.id).then(() => fetchTabs())
              }),
              style: { borderRadius: 8, marginBottom: 4 },
            })),
            ...(!editMode ? [{ key: '/dashboard/__add', icon: <PlusOutlined />, label: '新增看板', style: { borderRadius: 8, marginBottom: 4 } }] : []),
          ],
        }
      }
      if (m.key === '/tools') {
        return {
          key: m.key, icon: m.icon,
          label: wrapLabel(m.label, m.key),
          children: [
            ...toolTabList.map((t, i) => ({
              key: `/tools/${t.id}`, icon: TOOL_ICONS[i % TOOL_ICONS.length],
              label: wrapLabel(t.name, `/tools/${t.id}`, (e) => {
                e.stopPropagation()
                toolTabs.remove(t.id).then(() => fetchTabs())
              }),
              style: { borderRadius: 8, marginBottom: 4 },
            })),
            ...(!editMode ? [{ key: '/tools/__add', icon: <PlusOutlined />, label: '新增工具', style: { borderRadius: 8, marginBottom: 4 } }] : []),
          ],
        }
      }
      return { key: m.key, icon: m.icon, label: wrapLabel(m.label, m.key), style: { borderRadius: 8, marginBottom: 4 } }
    })

  const selectedKey = pathname.startsWith('/dashboard/') ? pathname
    : pathname.startsWith('/tools/') ? pathname
    : (ALL_MENU.find(m => m.key !== '/' && pathname.startsWith(m.key))?.key ?? '/')
  const currentModule = ALL_MENU.find(m => m.key !== '/' && pathname.startsWith(m.key))?.moduleKey ?? 'home'

  if (!can(currentModule) && menuItems.length > 0) return <Navigate to={menuItems[0].key} replace />
  if (menuItems.length === 0) return <div style={{ padding: 24, color: '#999' }}>当前账号无任何模块访问权限，请联系管理员授权</div>

  const isDashboardTab = !!pathname.match(/^\/dashboard\/\d+/)
  const isToolTab = !!pathname.match(/^\/tools\/\d+/)
  const isFullscreenTab = isDashboardTab || isToolTab

  return (
    <Layout style={{ minHeight: '100vh' }}>
      {!(collapsed && isFullscreenTab) && (
        <Sider collapsible collapsed={false} trigger={null}
          width={220} className="puc-sidebar"
          style={{ background: '#fff', boxShadow: '2px 0 8px rgba(0,0,0,0.03)', zIndex: 10 }}>
          <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
          <div style={{
            height: 64, display: 'flex', alignItems: 'center', justifyContent: 'space-between',
            background: 'linear-gradient(90deg, #536DFE 0%, #798DFE 100%)',
            color: '#fff', fontWeight: 700, fontSize: 17, letterSpacing: 0.5,
            padding: '0 16px',
          }}>
            <span style={{ cursor: 'pointer' }} onClick={() => navigate('/')}>付费运营中心</span>
            {isFullscreenTab && (
              <MenuFoldOutlined onClick={() => setCollapsed(true)}
                style={{ fontSize: 16, cursor: 'pointer', color: '#fff' }} />
            )}
          </div>
          <div style={{ padding: '12px 16px', borderBottom: '1px solid #f0f0f0', display: 'flex', alignItems: 'center', gap: 8 }}>
            <Avatar size={32} style={{ background: '#FFC260', color: '#fff', fontWeight: 600, flexShrink: 0 }}>
              {user?.name?.[0] ?? 'U'}
            </Avatar>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontSize: 13, fontWeight: 600, color: '#4A4A4A', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{user?.name}</div>
              <a onClick={logout} style={{ fontSize: 12, color: '#999', cursor: 'pointer' }}>退出登录</a>
            </div>
          </div>

          {editMode && (
            <div style={{ background: '#fff7e6', padding: '6px 16px', fontSize: 12, color: '#fa8c16', borderBottom: '1px solid #ffe7ba', display: 'flex', alignItems: 'center', gap: 6 }}>
              <EditOutlined /> 编辑模式：点击 ✕ 删除菜单项
            </div>
          )}

          <div style={{ flex: 1, overflow: 'auto' }}>
            <Menu mode="inline" selectedKeys={[selectedKey]}
              style={{ border: 'none', padding: '12px 8px' }}
              items={menuItems}
              onClick={({ key }) => {
                if (editMode) return
                if (key === '/dashboard/__add') { setAddModalType('dashboard'); setAddModalOpen(true); return }
                if (key === '/tools/__add') { setAddModalType('tools'); setAddModalOpen(true); return }
                if (key === '__ops_backends/__add') {
                  setAddModalType('ops')
                  setAddForm({ name: '', url: '', owner: '', description: '', open_mode: 'new_window' })
                  setAddModalOpen(true)
                  return
                }
                const dynOpsMatch = key.match(/^__ops_dyn_(\d+)$/)
                if (dynOpsMatch) {
                  const item = opsList.find(o => o.id === Number(dynOpsMatch[1]))
                  if (item) {
                    if (item.open_mode === 'iframe') navigate(`/ops-iframe/${item.id}`)
                    else window.open(item.url, '_blank')
                  }
                  return
                }
                const extItem = ALL_MENU.find(mm => mm.key === key && mm.external)
                if (extItem) { window.open(extItem.external, '_blank'); return }
                const opsMenu = ALL_MENU.find(mm => mm.key === '__ops_backends')
                const opsChild = opsMenu?.children?.find((c: any) => c.key === key)
                if (opsChild) {
                  if (opsChild.external) window.open(opsChild.external, '_blank')
                  else if (opsChild.route) navigate(opsChild.route)
                  return
                }
                const toolMatch = key.match(/^\/tools\/(\d+)$/)
                if (toolMatch) {
                  const tab = toolTabList.find(t => t.id === Number(toolMatch[1]))
                  if (tab && tab.open_mode === 'new_window') { window.open(tab.url, '_blank'); return }
                }
                navigate(key)
              }}
            />
          </div>

          {isSuperAdmin && (
            <div
              onClick={() => setEditMode(v => !v)}
              style={{
                padding: '10px 16px', cursor: 'pointer', borderTop: '1px solid #f0f0f0',
                display: 'flex', alignItems: 'center', gap: 8, fontSize: 13,
                color: editMode ? '#fa8c16' : '#555',
                background: editMode ? '#fff7e6' : '#f5f5f5',
                transition: 'all 0.2s',
                flexShrink: 0,
              }}
            >
              {editMode ? <CheckOutlined /> : <EditOutlined />}
              {editMode ? '完成编辑' : '编辑菜单'}
            </div>
          )}
          </div>
        </Sider>
      )}
      <Layout style={{ background: '#F6F7FF' }}>
        <Content style={{ margin: collapsed && isFullscreenTab ? 0 : 24, minHeight: 280 }}>
          <Outlet context={{ collapsed, setCollapsed }} />
        </Content>
      </Layout>

      <Modal
        title={addModalType === 'dashboard' ? '新增看板' : addModalType === 'ops' ? '新增常用后台' : '新增运营工具'}
        open={addModalOpen}
        onOk={async () => {
          if (!addForm.name.trim() || !addForm.url.trim()) return
          if (addModalType === 'ops') {
            await opsBackends.create({ name: addForm.name.trim(), url: addForm.url.trim(), description: addForm.description.trim(), open_mode: addForm.open_mode })
            setAddForm({ name: '', url: '', owner: '', description: '', open_mode: 'new_window' })
            setAddModalOpen(false)
            fetchTabs()
            return
          }
          const api = addModalType === 'dashboard' ? dashboardTabs : toolTabs
          const payload: any = { name: addForm.name.trim(), url: addForm.url.trim(), owner: addForm.owner.trim(), description: addForm.description.trim() }
          if (addModalType === 'tools') payload.open_mode = addForm.open_mode
          const created: any = await api.create(payload)
          setAddForm({ name: '', url: '', owner: '', description: '', open_mode: 'iframe' })
          setAddModalOpen(false)
          fetchTabs()
          if (addModalType === 'tools' && addForm.open_mode === 'new_window') {
            window.open(addForm.url.trim(), '_blank')
          } else {
            navigate(addModalType === 'dashboard' ? `/dashboard/${created.id}` : `/tools/${created.id}`)
          }
        }}
        onCancel={() => setAddModalOpen(false)}
        okText="添加" cancelText="取消"
      >
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          <Input placeholder={addModalType === 'ops' ? '名称' : '工具名称'} value={addForm.name} onChange={e => setAddForm(f => ({ ...f, name: e.target.value }))} />
          <Input placeholder="跳转地址（URL）" value={addForm.url} onChange={e => setAddForm(f => ({ ...f, url: e.target.value }))} />
          {addModalType !== 'ops' && <Input placeholder="负责人" value={addForm.owner} onChange={e => setAddForm(f => ({ ...f, owner: e.target.value }))} />}
          <Input placeholder="简介" value={addForm.description} onChange={e => setAddForm(f => ({ ...f, description: e.target.value }))} />
          {(addModalType === 'tools' || addModalType === 'ops') && (
            <div>
              <div style={{ fontSize: 13, color: '#666', marginBottom: 4 }}>打开方式</div>
              <Radio.Group value={addForm.open_mode} onChange={e => setAddForm(f => ({ ...f, open_mode: e.target.value }))}>
                <Radio value="iframe">PUC中心打开</Radio>
                <Radio value="new_window">新窗口打开</Radio>
              </Radio.Group>
            </div>
          )}
        </div>
      </Modal>
    </Layout>
  )
}
